import React, { Component } from 'react';

export default function asyncComponent(componentName, componentKey) {

    class AsyncComponent extends Component {

        constructor(props) {
            super(props);

            this.state = {
                component: null,
            };
        }

        async componentDidMount() {
            let importComponent = (() => import('' + componentName));
            const component = await importComponent();

            this.setState({
                component: component[componentKey]
            });
        }

        render() {
            const C = this.state.component;

            return C
                ? <C {...this.props} />
                : null;
        }

    }

    return AsyncComponent;
}